import React from 'react';
import { Crown, ArrowRight, TrendingUp, Users, Check } from 'lucide-react';
import { motion } from 'framer-motion';
export function LeadershipPage() {
  return <div className="min-h-screen w-full bg-[#0A0F1C] text-slate-200 selection:bg-[#7FE0C3]/30 font-sans" data-id="element-953" data-mp="1qjiz2l95jka1">
      {/* 1. HERO */}
      <section className="relative pt-32 pb-8 px-6 md:px-12 max-w-7xl mx-auto text-center" data-id="element-954" data-mp="1zlih9gvwkuek">
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-96 bg-[#7FE0C3]/5 blur-[120px] rounded-full pointer-events-none" data-id="element-955" data-mp="2eaofp2mx2gle" />

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-956" data-mp="29b21apvcqub0">
          <div className="inline-block px-3 py-1 rounded-full bg-[#7FE0C3]/10 border border-[#7FE0C3]/20 text-[#7FE0C3] text-xs font-bold uppercase tracking-widest mb-6" data-id="element-957" data-mp="sxlp5c8u8n9p">
            Executive Recruiting
          </div>
          <h1 className="text-5xl md:text-7xl font-bold text-white mb-6 tracking-tight" data-id="element-958" data-mp="3cmo8qbnew3gb">
            HIRE Leadership
          </h1>
          <p className="text-xl md:text-2xl text-slate-400 max-w-3xl mx-auto mb-8 leading-relaxed" data-id="element-959" data-mp="3hlr4t6leyzc5">
            For companies that need to recruit leadership-level talent to scale
            their D2D and home services operation.
          </p>
          <p className="text-lg text-slate-500 max-w-2xl mx-auto border-t border-slate-800 pt-8" data-id="element-960" data-mp="3vcnuopnyh2fi">
            Finding managers and team leaders requires a different approach. We
            build and run targeted campaigns to attract the leaders who will
            drive your team's growth.
          </p>
        </motion.div>
      </section>

      {/* 2. PRICING */}
      <section className="pt-4 pb-20 px-6 md:px-12 max-w-6xl mx-auto" data-id="element-961" data-mp="e3r3ube9zu81">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-962" data-mp="2axu78mfkxzzw">
          {/* Build Fee */}
          <div className="bg-slate-900/40 border border-slate-800 p-6 rounded-xl relative overflow-hidden" data-id="element-963" data-mp="2fwx59mx575yd">
            <div className="mb-4" data-id="element-964" data-mp="27vz7fj8vn4q8">
              <div className="text-xs text-slate-500 uppercase tracking-widest mb-2" data-id="element-965" data-mp="27xaebrxmcslk">
                Build and Implementation (One-Time)
              </div>
              <div className="text-3xl font-bold text-white" data-id="element-966" data-mp="2huf3m0mrh46l">$7,500</div>
              <ul className="mt-5 space-y-2.5 pt-4 border-t border-slate-800/50" data-id="element-967" data-mp="2ctrc7dumelbu">
                {['Leadership opportunity and company profiling', 'Custom ATS with dashboards, workflows, and job board integrations', 'Culture video and leadership-focused ad copywriting', 'Landing pages and executive application flows', 'Targeted campaign design built to reach experienced operators', 'Compensation and role benchmarking by region', 'Pre-launch system stress test', 'Covers build and implementation of standard and leadership campaign'].map((point, i) => <li key={i} className="flex items-start" data-id="element-968" data-mp="3o8bhwj1b0oyv" data-mpi={i}>
                    <Check className="w-3.5 h-3.5 text-[#7FE0C3] mr-2 mt-0.5 shrink-0" data-id="element-969" data-mp="3t6d1r66k0sbe" />
                    <span className="text-slate-400 text-sm leading-snug" data-id="element-970" data-mp="3t3z36nco0xz3">
                      {point}
                    </span>
                  </li>)}
              </ul>
            </div>
          </div>

          {/* Monthly Total */}
          <div className="bg-slate-900/40 border border-[#7FE0C3]/30 p-6 rounded-xl relative" data-id="element-971" data-mp="35fz5f3gxs7b0">
            <div className="absolute top-0 left-0 w-full h-1 bg-[#7FE0C3] rounded-t-xl" data-id="element-972" data-mp="3a89355oambnu" />
            <div className="mb-4" data-id="element-973" data-mp="2wh3z7rdw6x7p">
              <div className="text-xs text-[#7FE0C3] uppercase tracking-widest mb-2" data-id="element-974" data-mp="2wdzm24ig8r4w">
                Total Monthly
              </div>
              <div className="text-4xl font-bold text-white mb-1" data-id="element-975" data-mp="2mi6ez0ni1pui">$2,500</div>
              <div className="text-sm text-slate-500 mb-6" data-id="element-976" data-mp="2mk931f53d8wl">/ month</div>

              <div className="space-y-3 pt-4 border-t border-slate-800/50" data-id="element-977" data-mp="2rg7vbdtjjb2a">
                <div className="flex justify-between text-sm" data-id="element-978" data-mp="3ttcjihw3hib5">
                  <span className="text-slate-400" data-id="element-979" data-mp="3pt2bz0snmju6">Campaign Management</span>
                  <span className="text-white font-medium" data-id="element-980" data-mp="3pv6cr9v9b2q8">$2,500</span>
                </div>
              </div>

              <ul className="mt-5 space-y-2.5 pt-4 border-t border-slate-800/50" data-id="element-981" data-mp="3g30lk2ctwpc3">
                {['Active ad management and real-time optimization', 'Targeted outreach to experienced operators and team leaders', 'Interview execution handled for you', 'Vetted candidates passed to you for final approval only', 'Monthly recruiting review and ongoing consulting'].map((point, i) => <li key={i} className="flex items-start" data-id="element-982" data-mp="10buvrym0mvfz" data-mpi={i}>
                    <Check className="w-3.5 h-3.5 text-[#7FE0C3] mr-2 mt-0.5 shrink-0" data-id="element-983" data-mp="10bcswj4uliz3" />
                    <span className="text-slate-400 text-sm leading-snug" data-id="element-984" data-mp="ve3495pa9bcb">
                      {point}
                    </span>
                  </li>)}
              </ul>
            </div>
          </div>

          {/* Performance Pricing */}
          <div className="bg-slate-900/40 border border-slate-800 p-6 rounded-xl" data-id="element-985" data-mp="1cmcigyyz2znh">
            <div className="mb-4" data-id="element-986" data-mp="1hl78olz9rqhm">
              <div className="text-xs text-[#7FE0C3] uppercase tracking-widest mb-4" data-id="element-987" data-mp="1hlgr9ohzivda">
                Performance Pricing
              </div>
              <div className="flex items-baseline mb-2" data-id="element-988" data-mp="jzjca12td863">
                <span className="text-3xl font-bold text-white" data-id="element-989" data-mp="oxku6ioi71fz">2.5%</span>
                <span className="text-slate-400 ml-2 text-sm" data-id="element-990" data-mp="tvupcta8a21l">of revenue</span>
              </div>
              <p className="text-sm text-slate-400 mb-4" data-id="element-991" data-mp="xwy7jmfr0a5z">Capped at $15,000</p>
              <div className="bg-slate-900/60 border border-slate-700/50 rounded-lg p-3" data-id="element-992" data-mp="xuv708gyyyn0">
                <p className="text-xs text-slate-400 flex items-start leading-relaxed" data-id="element-993" data-mp="25cug3kgxg8ti">
                  <ArrowRight className="w-3.5 h-3.5 text-[#7FE0C3] mr-2 mt-0.5 shrink-0" data-id="element-994" data-mp="29ajv535ym3pe" />
                  <span data-id="element-995" data-mp="a61y8nsnra32">
                    Based on the leader's{' '}
                    <strong className="text-slate-200" data-id="element-996" data-mp="57gvagm0ucax">
                      personal and team
                    </strong>{' '}
                    production combined.
                  </span>
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-8 p-6 bg-[#7FE0C3]/5 border border-[#7FE0C3]/20 rounded-lg max-w-3xl mx-auto" data-id="element-997" data-mp="3moi7r6vecciw">
          <p className="text-[#7FE0C3] text-center font-medium" data-id="element-998" data-mp="3io7r909za3ps">
            Ad spend is paid directly to the job platforms and is separate from
            HIRE's fees.
          </p>
        </div>
      </section>

      {/* 3. WHO LEADERSHIP IS FOR */}
      <section className="py-20 px-6 md:px-12 max-w-5xl mx-auto border-t border-slate-800/50" data-id="element-999" data-mp="3rm09odazxrhe">
        <div className="text-center mb-12" data-id="element-1000" data-mp="33wfnlljjqe3w">
          <h2 className="text-3xl font-bold text-white mb-4" data-id="element-1001" data-mp="2yzz1sxztkbtz">
            Why Leadership Recruiting Is Different
          </h2>
          <p className="text-slate-400 text-lg max-w-2xl mx-auto" data-id="element-1002" data-mp="1eglie6v436zp">
            Recruiting managers and team leaders requires a different approach
            than recruiting reps.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center" data-id="element-1003" data-mp="15i9uwdpjkpbh">
          <div className="space-y-4 text-slate-400" data-id="element-1004" data-mp="1aguss6hbmwwr">
            <p data-id="element-1005" data-mp="1adfgfbf181z1">
              Leadership-level talent doesn't respond to mass recruiting
              funnels. They aren't looking, so they need to be found.
            </p>
            <p data-id="element-1006" data-mp="2266bhikzbkmp">
              We build dedicated campaigns designed to attract operators who can
              run teams, drive culture, and own production at scale.
            </p>
            <p data-id="element-1007" data-mp="1t4zvrbq5mdui">
              Because the impact of one strong leader compounds, the pricing is
              aligned to outcomes, not activity.
            </p>
          </div>
          <div className="bg-slate-900/40 border border-[#7FE0C3]/20 rounded-xl p-8 space-y-6" data-id="element-1008" data-mp="hre49jwto05t">
            <div className="flex items-start" data-id="element-1009" data-mp="19ez1ax41myxz">
              <div className="w-12 h-12 rounded-full bg-[#7FE0C3]/10 flex items-center justify-center mr-4 flex-shrink-0 border border-[#7FE0C3]/20" data-id="element-1010" data-mp="19cm97r4kn877">
                <Users className="w-6 h-6 text-[#7FE0C3]" data-id="element-1011" data-mp="zfq0bkargk24" />
              </div>
              <div data-id="element-1012" data-mp="uhoi11l5sorp">
                <h3 className="text-white font-bold mb-2" data-id="element-1013" data-mp="ui81wnuddn8d">
                  Interviews Handled
                </h3>
                <p className="text-slate-400 text-sm" data-id="element-1014" data-mp="1s3vlu99n2d30">
                  We run the interview process and only pass candidates to you
                  for final approval, so leadership time stays focused on
                  production.
                </p>
              </div>
            </div>
            <div className="flex items-start" data-id="element-1015" data-mp="1df93rzsmn783">
              <div className="w-12 h-12 rounded-full bg-[#7FE0C3]/10 flex items-center justify-center mr-4 flex-shrink-0 border border-[#7FE0C3]/20" data-id="element-1016" data-mp="1deg57m3tno11">
                <TrendingUp className="w-6 h-6 text-[#7FE0C3]" data-id="element-1017" data-mp="2646cbb71dpnn" />
              </div>
              <div data-id="element-1018" data-mp="2eeds8wodmzf8">
                <h3 className="text-white font-bold mb-2" data-id="element-1019" data-mp="2eex7g5mn79pk">
                  Performance Aligned
                </h3>
                <p className="text-slate-400 text-sm" data-id="element-1020" data-mp="2ifh5rciycjda">
                  You only pay more when the leader's team actually produces.
                  Performance pricing kicks in at production milestones, not at
                  hire.
                </p>
              </div>
            </div>
            <div className="flex items-start" data-id="element-1021" data-mp="2xc7w6wanekqr">
              <div className="w-12 h-12 rounded-full bg-[#7FE0C3]/10 flex items-center justify-center mr-4 flex-shrink-0 border border-[#7FE0C3]/20" data-id="element-1022" data-mp="31dte4w21hp7t">
                <Crown className="w-6 h-6 text-[#7FE0C3]" data-id="element-1023" data-mp="365jvhlze9d8q" />
              </div>
              <div data-id="element-1024" data-mp="3b2jq90qsmtkj">
                <h3 className="text-white font-bold mb-2" data-id="element-1025" data-mp="3b338kikcvjz3">Targeted Outreach</h3>
                <p className="text-slate-400 text-sm" data-id="element-1026" data-mp="3g491ohhxh995">
                  Campaigns are built to attract experienced operators, not
                  generic applicants.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 4. CTA */}
      <section className="py-32 px-6 md:px-12 text-center border-t border-slate-800/50" data-id="element-1027" data-mp="19pvgaz9fgsrc">
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-8" data-id="element-1028" data-mp="1enokjmr67coz">
          Ready to recruit leaders who scale your team?
        </h2>
        <button className="inline-flex items-center px-8 py-4 bg-[#7FE0C3] hover:bg-[#5ACCA8] text-[#163A5F] font-bold rounded-lg transition-all transform hover:scale-105" data-id="element-1029" data-mp="1jfybn640uisu">
          Discuss Leadership
          <ArrowRight className="ml-2 w-5 h-5" data-id="element-1030" data-mp="1texkopsp8ggd" />
        </button>
      </section>
    </div>;
}